import { render, staticRenderFns } from "./_base-search-input.vue?vue&type=template&id=1536fc1e&scoped=true"
import script from "./_base-search-input.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-search-input.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-search-input.vue?vue&type=style&index=0&id=1536fc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1536fc1e",
  null
  
)

export default component.exports